export default "__VITE_ASSET__DuLVlJm2__"